import { render } from "./GPO.vue?vue&type=template&id=1a0c0999&scoped=true"
import script from "./GPO.vue?vue&type=script&lang=js"
export * from "./GPO.vue?vue&type=script&lang=js"

import "./GPO.vue?vue&type=style&index=0&id=1a0c0999&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0c0999"]])

export default __exports__